import { Info } from '@mui/icons-material';
import { Box, IconButton, Popover, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react';
import { ITeamRoleAlternate } from '../../Models/CareTeams/TeamRoleAlternate.model';

interface AlternateProviderBadgeProps {
    alternates: ITeamRoleAlternate[];
    roleId: string;
    onManageClick?: () => void;
}

export const AlternateProviderBadge: React.FC<AlternateProviderBadgeProps> = ({ alternates, roleId }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const relevantAlternates = alternates.filter((alt) => alt.RoleId === roleId);

    if (relevantAlternates.length === 0) {
        return null;
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                size="small"
                onClick={handleClick}
                sx={{
                    p: 0.5,
                    color: '#1976d2',
                    '&:hover': {
                        bgcolor: 'rgba(25, 118, 210, 0.04)',
                    },
                }}
                title={`${relevantAlternates.length} alternate(s)`}
            >
                <Info sx={{ fontSize: '1.25rem' }} />
            </IconButton>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 1.5 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell
                                    sx={{ fontWeight: 600, fontSize: '0.75rem', textTransform: 'uppercase', color: '#999', borderBottom: '1px solid #e0e0e0' }}
                                >
                                    Provider Name
                                </TableCell>
                                <TableCell
                                    sx={{ fontWeight: 600, fontSize: '0.75rem', textTransform: 'uppercase', color: '#999', borderBottom: '1px solid #e0e0e0' }}
                                >
                                    Member Name
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {relevantAlternates.map((alt, idx) => (
                                <TableRow key={idx} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                                    <TableCell sx={{ py: 1, fontSize: '0.875rem', fontWeight: 500 }}>{alt.ProviderName}</TableCell>
                                    <TableCell sx={{ py: 1, fontSize: '0.875rem' }}>
                                        {alt.MemberFirstName} {alt.MemberLastName}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Popover>
        </>
    );
};

export default AlternateProviderBadge;
